import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { media } from '../../theme';

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    position: relative;
    margin-bottom: 16px;
    
    ${media.md} {
        gap: 0;
    }
`;

export const LogoWrapper = styled.div<{ $clickable?: boolean }>`
    cursor: ${props => props.$clickable ? 'pointer' : 'default'};
    margin-top: 0;
    margin-bottom: 0;
    order: 2;

    ${media.md} {
        margin-top: 3%;
        margin-bottom: 4%;
        order: 0;
    }

    img {
        width: 200px;
        height: auto;

        ${media.md} {
            width: 240px;
        }
    }
`;

export const SwitcherWrapper = styled.div`
    display: flex;
    align-items: center;
    align-self: flex-end;
    order: 1;

    ${media.md} {
        align-self: auto;
        order: 0;
        position: absolute;
        top: 0;
        right: 0;
    }
`;

export const HelpLink = styled(Link)`
    display: flex;
    align-items: center;
    margin-left: 12px;

    svg {
        width: 24px;
        height: 24px;
        fill: ${({theme}) => theme.palette.primary.main};
        transition: fill 0.2s ease-in-out;
    }

    &:hover svg {
        fill: #000;
    }
`;
